import React from 'react';
import { useAppSelection } from '../contexts/AppSelectionContext';
import { useExamType } from '../contexts/ExamTypeContext';
import './AppSelectorModal.css';

const AppSelectorModal: React.FC = () => {
  const { showModal, setShowModal, selectedApp } = useAppSelection();
  const { getExamTypeName } = useExamType();

  if (!showModal || selectedApp) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Welcome to {getExamTypeName()}</h2>
          <p>Your comprehensive German citizenship test preparation app</p>
        </div>

        <div className="modal-body">
          <div className="app-info">
            <div className="app-icon">🇩🇪</div>
            <h3>Leben in Deutschland</h3>
            <p className="app-description">
              Master all 300 questions of the German citizenship test (Einbürgerungstest) with support for 8 languages.
            </p>
            <ul className="feature-list">
              <li>✅ 300 Official Questions</li>
              <li>✅ 8 Languages Available</li>
              <li>✅ All 16 German States</li>
              <li>✅ Mock Exams</li>
              <li>✅ Detailed Explanations</li>
            </ul>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="confirm-button"
            onClick={() => setShowModal(false)}
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppSelectorModal;

